module.exports = __webpack_public_path__ + "img/female.a0362db6.png";